import * as GrommetIcons from 'grommet-icons/es6';

const iconCache = {}; // Cache to store dynamically loaded icons

/**
 * Dynamically loads an icon component based on the icon name.
 * @param {string} iconName - The name of the icon to load.
 * @returns {React.Element} - The React component for the icon.
 */
export const loadIcon = (iconName) => {
  // If the icon is already cached, return it
  if (iconCache[iconName]) {
    return iconCache[iconName];
  }

  // Dynamically import the icon component and cache it
  const IconComponent = GrommetIcons[iconName];

  // If the icon exists, cache it and return it
  if (IconComponent) {
    iconCache[iconName] = IconComponent;
    return IconComponent;
  }

  console.warn(`Icon not found: ${iconName}`);
  return null; // Return null if the icon is not found
};


